// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ actions
const cardPinResetActions = require('actions/contactCenter/cardPinReset/cardPinReset');

// @ components
const CardPinResetView = require('components/contactCenter/cardPinResetView/cardPinResetView');

class CardPinResetViewContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <CardPinResetView {...this.props} />
        );
    }
}

CardPinResetViewContainer.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardPinReset: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    resetWizard: PropTypes.func.isRequired,
}

module.exports.constructor = CardPinResetViewContainer;
module.exports.CardPinResetViewContainer = connect(
    state => ({
        immProfile: state.profile,
        immCards: state.cards,
        immCardPinReset: state.cardPinReset
    }),
    {
        handleFinish: cardPinResetActions.handleFinish,
        resetWizard: cardPinResetActions.resetWizard,
        setVisibleStep: cardPinResetActions.setVisibleStep,
        validateStep: cardPinResetActions.validateStep,
    }
)(CardPinResetViewContainer);
